import { AgxButton, AgxModal, AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import './deleteConfirmation.scss';

interface DeleteConfirmationProps {
  name: string;
  title: string;
  lineOne: string;
  lineTwo: string;
  showPopUp: boolean;
  primaryActionTitle: string;
  secondaryActionTitle: string;
  disabled?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteConfirmation = ({
  showPopUp,
  name,
  title,
  lineOne,
  lineTwo,
  disabled = false,
  onConfirm,
  onClose,
  primaryActionTitle,
  secondaryActionTitle,
}: DeleteConfirmationProps) => (
  <AgxModal
    id="delete-confirmation-dialog"
    title={title}
    isOpen={showPopUp}
    setIsDialogOpen={(open) => {
      if (!open) onClose();
    }}
    type="single"
    variant="withoutDivider"
    actionButtonContainerStyle="withoutDivider"
    maxWidth="640px"
    content={
      <AgxSpacer direction="vertical" gap="md">
        <AgxTypography type="body" size="medium">
          {lineOne} <span className="usernameStyle__deleteConfirmation">{name}</span>?
        </AgxTypography>
        <AgxTypography type="body" size="medium">
          {lineTwo}
        </AgxTypography>
      </AgxSpacer>
    }
    actionButtons={
      <AgxSpacer direction="horizontal" gap="spacing-xl" fill>
        <AgxButton
          id="confirmDelete"
          text={primaryActionTitle}
          variant="primary"
          size="large"
          disabled={disabled}
          onClick={onConfirm}
        />
        <AgxButton
          id="cancelDelete"
          text={secondaryActionTitle}
          variant="hollow"
          size="large"
          onClick={onClose}
        />
      </AgxSpacer>
    }
  />
);

export default DeleteConfirmation;
